import { useQuery } from "@tanstack/react-query";
import { graphql, useStaticQuery } from "gatsby";

const serviceBaseUrl = process.env.GATSBY_BABEL_BASE_URL;

export const useAllProducts = (focusedCompatible) => {
  const {
    site: {
      siteMetadata: { babelPrefix },
    },
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          babelPrefix
        }
      }
    }
  `);

  return useQuery({
    queryKey: ["allProducts"],
    enabled: !!focusedCompatible,
    queryFn: async () => {
      try {
        const response = await fetch(`${serviceBaseUrl}/getproductslines/${babelPrefix}/haier`);
        const data = await response.json();
        const results = data.GetProductsLinesResult;
        const products = results
          .map((result) => result.products)
          .filter(Boolean)
          .flat()
          .map((item) => {
            return { label: item.name, value: item.name, code: item.code };
          });
        return products;
      } catch (err) {
        console.log("Load all products error: ", err);
      }
    },
  });
};
